import { getImageReference } from "@tiicker/util/lib/contentful/helpers";
import {
  ContentfulContentType,
  PerkDocument,
} from "@tiicker/util/lib/contentful/types";
import SwiperCarousel from "components/Carousel/SwiperCarousel";
import PerkCard from "components/core/PerkCard/PerkCard";
import React from "react";
import { useContentfulEntries } from "source/contentful/provider";
import styles from "./TrendingPerks.module.scss";

type Props = {
  perkIds: string[];
  titleOverride?: string;
};

const TrendingPerks = (props: Props) => {
  const perks = useContentfulEntries<PerkDocument>(ContentfulContentType.Perk, {
    query: {
      content_type: ContentfulContentType.Perk,
      "sys.id[in]": props.perkIds.join(","),
    },
  });

  return (
    <div className={styles.container}>
      <div className="container">
        <h2 className={styles.title}>
          {props.titleOverride || "Trending perks"}
        </h2>
      </div>
      {perks.state === "DONE" && (
        <>
          <SwiperCarousel
            pagination
            navigation
            spaceBetween={24}
            slidesPerGroup={3}
            slideClass={styles.slide}
            swiperClass={styles.swiper}
            openSide="right"
            breakPoints={{
              1000: {
                slidesPerGroup: 3,
              },
              768: {
                slidesPerGroup: 2,
              },
              100: {
                slidesPerGroup: 1,
              },
            }}
            slides={perks.result.items
              .filter((perk) => new Date(perk.fields.endDate) > new Date())
              .slice(0, 5)
              .map((perk, i) => {
                const image = getImageReference(
                  perk.fields.image,
                  perks.result.includes
                );
                const logoImage = getImageReference(
                  perk.fields.brand.fields.companyLogoDark,
                  perks.result.includes
                );

                return (
                  <PerkCard
                    id={perk.sys.id}
                    imageUrl={image?.fields.file.url ?? ""}
                    title={perk.fields.title}
                    noAnimate
                    className={styles.perkCard}
                    cardClassName={styles.perkCardClassName}
                    brandLogo={logoImage?.fields.file.url ?? ""}
                    tickerSymbol={perk.fields.brand.fields.tickerSymbol ?? ""}
                    imageClassName={styles.perkCardImage}
                    limitedQuantityNumber={perk.fields.limitedQuantityNumber}
                  />
                );
              })}
          />
        </>
      )}
    </div>
  );
};

export default TrendingPerks;
